/**
 * splitIntoLines
 * A piece of writing as paragraphs of sentences, for tap-a-line reading.
 * Each sentence is an exact slice of the text, so the server can check it with
 * content.includes(line). Naive on "Mr." style abbreviations, which just split early.
 */

const SENTENCE = /[^.!?…]+(?:[.!?…]+["'”’)\]]*|$)/g;

export function splitIntoLines(text) {
  return String(text || '')
    .split(/\n+/)
    .map((para) => (para.match(SENTENCE) || []).map((s) => s.trim()).filter(Boolean))
    .filter((para) => para.length);
}
